// socket.js
import { io } from "socket.io-client";

const socket = io("http://localhost:8080", {
    transports: ["websocket"],
    withCredentials: true,
});

socket.onAny((event, ...args) => {
    console.log(`📡 Socket event: ${event}`, args);
});

export default socket;
